import React from 'react'
import { Outlet } from 'react-router-dom'

const Investment = () => {
  return (
    <div>
      <Outlet />
    </div>
  )
}

export default Investment